<template>
  <Toast />
  <div class="p-grid">
    <div class="p-col-12">
      <Panel header="Consultar Solicitações">
        <Toolbar class="p-mb-4">
          <template #end>
            <div
              class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-between"
            >
              <Button
                label="Exportar"
                icon="pi pi-download"
                class="mr-2"
                @click="exportCSV()"
              />
            </div>
          </template>
        </Toolbar>
        <DataTable
          ref="dt"
          dataKey="id"
          class="p-datatable-sm"
          :value="list"
          :paginator="true"
          filterDisplay="row"
          :rows="10"
          :rowsPerPageOptions="[10, 20, 50, 100, 500, 1000]"
          :filters="filters"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Exibindo de {first} a {last} no total de {totalRecords} solicitações."
          :lazy="true"
          :totalRecords="totalRecords"
          :loading="loading"
          @page="onPage($event)"
          @filter="onFilter($event)"
          @sort="onSort($event)"
        >
          <template #empty>
            <div class="p-text-center">Nenhum resultado encontrado...</div>
          </template>

          <Column field="id" header="Protocolo" ref="id">
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="number"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter"
                placeholder="Protocolo"
              />
            </template>

            <template #body="slotProps">
              <small v-if="slotProps.data.id">
                <b>
                  {{ slotProps.data.id }}
                </b>
              </small>
              <small v-else>
                <i class="pi pi-key"></i>
              </small>
            </template>
          </Column>
          <Column header="Solicitante" field="requester">
            <template #body="slotProps">
              {{ slotProps.data.requester }}
            </template>
          </Column>
          <Column header="Setor" filterField="setorId" field="acronym">
            <template #filter="{ filterModel, filterCallback }">
              <Dropdown
                v-model="filterModel.value"
                placeholder="Selecione um setor"
                filterPlaceholder="Digite a sigla do setor"
                :options="sectors"
                @filter="filterSector"
                optionLabel="acronym"
                :filter="true"
                :showClear="true"
                optionValue="id"
                @change="filterCallback()"
              />
            </template>
            <template #body="slotProps">
              {{ slotProps.data.acronym }}
            </template>
          </Column>
          <Column header="Prioridade" field="priority">
            <template #body="slotProps">
              <span
                :class="'solicitacao-badge status-' + slotProps.data.priority"
                >{{ $Util.formatBoolean(slotProps.data.priority) }}</span
              >
            </template>
          </Column>
          <Column header="Operador Responsável" field="operator">
            <template #body="slotProps">
              {{ slotProps.data.operator }}
            </template>
          </Column>
          <Column header="Situação" field="status" filterField="status">
            <template #filter="{ filterModel, filterCallback }">
              <Dropdown
                v-model="filterModel.value"
                placeholder="Selecione um status"
                :options="StatusSolicitation"
                optionLabel="name"
                optionValue="key"
                :showClear="true"
                @change="filterCallback()"
              />
            </template>
            <template #body="slotProps">
              <span
                :class="
                  'solicitacao-badge status-' +
                  slotProps.data.status.toLowerCase()
                "
                >{{ $Util.formatStatus(slotProps.data.status) }}</span
              >
            </template>
          </Column>
          <Column header="Data" field="date">
            <template #filter="{ filterModel, filterCallback }">
              <InputMask
                mask="99/9999"
                v-model="filterModel.value"
                placeholder="MM/YYYY"
                @change="filterCallback()"
              />
            </template>
            <template #body="slotProps">
              {{ $DateTime.formatarDateTime24hours(slotProps.data.date) }}
            </template>
          </Column>
          <Column header="Ações">
            <template #body="slotProps">
              <Button
                icon="pi pi-download"
                v-if="slotProps.data.url"
                class="p-button-rounded p-button-success mr-2"
                @click="showOs(slotProps.data)"
                v-tooltip.top="'CLIQUE PARA VER DETALHES'"
              />
              <Button
                icon="pi pi-eye"
                class="p-button-rounded mr-2"
                @click="showDetails(slotProps.data)"
                v-tooltip.top="'CLIQUE PARA VER DETALHES'"
              />
            </template>
          </Column>
        </DataTable>
      </Panel>
    </div>
  </div>

  <!--MODAL CADASTRAR-->
  <dialog-details :objSelected="obj" />
  <!--FIM MODAL CADASTRAR-->
</template>

<script>
//models
import { StatusSolicitation } from "../../models/enums/Status";

//Services
import SolicitationService from "../../service/solicitation/solicitation_service";
import SectorService from "../../service/sector/sector_service";

//components
import DialogDetails from "../../components/solicitation/dialog-details.vue";

export default {
  components: {
    DialogDetails,
  },
  data() {
    return {
      loading: false,
      list: [],
      obj: {},
      filters: {
        id: { value: "", matchMode: "contains" },
        status: { value: "", matchMode: "contains" },
        setorId: { value: "0", matchMode: "contains" },
        date: { value: "0", matchMode: "contains" },
      },
      service: new SolicitationService(),
      sectorService: new SectorService(),
      StatusSolicitation,
      lazyParams: {},
      sectors: [],
    };
  },
  created() {},
  mounted() {
    this.lazyParams = {
      first: 0,
      rows: this.$refs.dt.rows,
      sortField: null,
      sortOrder: null,
      id: "",
      status: "",
      setorId: "0",
    };
    this.loadLazyData();
  },
  methods: {
    showDetails(objDto) {
      this.obj = objDto;
      this.$store.state.views.solicitation.consult.dialogDetails = true;
    },
    showOs(obj) {
      if (obj.url.includes("https://firebasestorage")) {
        window.open(obj.url);
      } else {
        this.service.download(obj.id);
      }
    },
    clearFilter() {
      if (this.lazyParams.id == null) {
        this.lazyParams.id = "";
      }
      if (this.lazyParams.status == null) {
        this.lazyParams.status = "";
      }

      if (this.lazyParams.setorId == null) {
        this.lazyParams.setorId = "";
      }

      if (this.lazyParams.mes == null) {
        this.lazyParams.mes = "";
      }

      if (this.lazyParams.ano == null) {
        this.lazyParams.ano = "";
      }
    },
    loadLazyData() {
      this.loading = true;

      this.clearFilter();

      this.service
        .findAllDTO(this.lazyParams)
        .then((data) => {
          this.list = data.content;
          this.totalRecords = data.totalElements;
          this.loading = false;
        })
        .catch(() => {
          this.$toast.add({
            severity: "error",
            detail: `Desculpe. Não foi possível carregar os dados.`,
          });
          this.loading = false;
          this.list = [];
        });
    },
    findById() {
      this.loading = true;
      this.service
        .findById(this.lazyParams.id)
        .then((data) => {
          this.list = [data];
          this.totalRecords = 1;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$msgErro(err);
        });
    },
    onPage(event) {
      this.lazyParams.rows = event.rows;
      this.lazyParams.page = event.page;
      this.loadLazyData();
    },
    onSort(event) {
      this.lazyParams.sortField = event.sortField;
      this.lazyParams.sortOrder = event.sortOrder;
      this.loadLazyData();
    },
    onFilter(event) {
      this.lazyParams.page = 0;
      this.lazyParams.id = event.filters.id.value;
      this.lazyParams.status = event.filters.status.value;
      this.lazyParams.setorId = event.filters.setorId.value;

      this.lazyParams.mes = 0;
      this.lazyParams.ano = 0;

      const date = event.filters.date.value.split("/");
      if (date.length > 1) {
        this.lazyParams.mes = date[0];
        this.lazyParams.ano = date[1];
      }

      this.loadLazyData();
    },
    filterSector(event) {
      this.sectorService.findAllByFilter(event.value).then((data) => {
        this.sectors = data.content;
      });
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../App.scss");
</style>
